import { register } from "@shopify/theme-sections";
import Swiper from "swiper/bundle";

register("lifestyle-product", {
  initSlider() {
    const carouselID = this.container.dataset.sectionId;
    const lifestyleCarousel = this.container.querySelector(
      ".lifestyle-product__carousel"
    );
    if (!lifestyleCarousel) return;
    const lifestyleSwiper = new Swiper(lifestyleCarousel, {
      loop: false,
      slidesPerView: 1.4,
      spaceBetween: 15,
      centeredSlides: true,
      autoplay: false,
      navigation: {
        nextEl: `.lifestyle-product[data-section-id="${carouselID}"] .swiper-button-next`,
        prevEl: `.lifestyle-product[data-section-id="${carouselID}"] .swiper-button-prev`,
      },
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
      },
    });
  },
  onLoad: function (e) {
    this.initSlider();
  },
});
